import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Menu } from 'antd';
import {
    PlusOutlined,
    SearchOutlined,
    OrderedListOutlined
} from '@ant-design/icons';

function Gestcontaopc() {
    const history = useHistory();
    const ref = useRef([]);

    useEffect(() => {
        localStorage.setItem('minheight', ref.current.offsetHeight);
    }, []);

    const handleClick = (item) => {
        if (item.onClick) {
            item.onClick();
        }
    };

    const menuItems = [
        { key: 'registarContadores', label: 'Registar Contadores', icon: <PlusOutlined />, onClick: () => history.push('/home/gest-contadores/importar-contador') },
        { key: 'pesquisarContador', label: 'Pesquisar Contador', icon: <SearchOutlined />, onClick: () => history.push('/home/gest-contadores/pesquisar-contador') },
        { key: 'listarContadores', label: 'Listar Contadores', icon: <OrderedListOutlined />, onClick: () => history.push('/home/gest-contadores/listar-contador') },
    ];

    return (
        <div className="opc" ref={ref}>
            <Menu mode="horizontal" onClick={({ key }) => handleClick(menuItems.find(item => item.key === key))}>
                {menuItems.map(item => (
                    <Menu.Item key={item.key} icon={item.icon}>
                        {item.label}
                    </Menu.Item>
                ))}
            </Menu>
        </div>
    );
}

export default Gestcontaopc;
